import { useQuery } from '@tanstack/react-query';
import { fetchActiveHandBack, type ActiveHandBack } from '../../../../services/finalReview';
import { FINAL_REVIEW_HAND_BACK_KEY } from '../../../../hooks/queryKeys';

export function useFinalReviewHandBack(patientId: string): ActiveHandBack | null {
    const { data } = useQuery({
        queryKey: FINAL_REVIEW_HAND_BACK_KEY(patientId),
        queryFn: () => fetchActiveHandBack(patientId)
    });
    return data ?? null;
}
